<template>
  <div class="rotate-tooltip">
    <CloseIcon
        :lineLength="16"
        circleBorderWidth="0"
        circleCrossColor="white"
    />

    <div class="icon-column">
      <svg
        width="72.306"
        height="87.406"
        viewBox="0 0 72.306 87.406"
        class="hand-icon"
      >
        <g transform="translate(-50 -36)">
          <path
            d="M53.848,50.293l7.421-7.421c0-.275.275-.275.275-.825a1.01,1.01,0,0,0-.275-.825l-.825-.55a.959.959,0,0,0-.55-.275c-.275,0-.55.275-.825.275l-8.8,8.8a1.374,1.374,0,0,0,0,1.649l8.8,8.8a1.374,1.374,0,0,0,1.649,0l.55-.825a1.031,1.031,0,0,0,0-1.649Z"
            fill="#415b91"
          />
          <path
            d="M111.844,108.838c-.275.275-.275.55-.275,1.1l-.825,7.421a1.773,1.773,0,0,1-1.649,1.649H85.182a1.773,1.773,0,0,1-1.649-1.649l-.55-7.146a1.429,1.429,0,0,0-.55-1.1c-1.649-2.473-9.9-14.842-7.971-21.714a6.019,6.019,0,0,1,3.3-3.573,2.448,2.448,0,0,0,1.374-2.2V54.416a4.552,4.552,0,0,1,1.374-3.3,5.071,5.071,0,0,1,3.3-1.374,4.454,4.454,0,0,1,4.673,4.673V67.334a2.463,2.463,0,0,0,2.474,2.474H92.6a5.953,5.953,0,0,1,5.222,2.749,2.488,2.488,0,0,0,2.749.825,6.051,6.051,0,0,1,2.2-.275,6.687,6.687,0,0,1,5.5,3.023,2.259,2.259,0,0,0,1.649,1.1c1.924,0,6.871.825,7.971,7.7C118.99,92.621,117.066,100.867,111.844,108.838ZM92.6,60.738v-6.6a8.363,8.363,0,0,0-3.023-6.6,9.6,9.6,0,0,0-6.047-2.2,8.469,8.469,0,0,0-8.8,8.8V80.253a10.775,10.775,0,0,0-4.673,5.772c-1.1,3.848-.275,9.07,2.749,15.392a65.341,65.341,0,0,0,5.5,9.62l.55,6.6a6.468,6.468,0,0,0,6.047,5.772H108.82a5.974,5.974,0,0,0,6.047-5.222l.825-6.872c5.772-8.795,7.7-18.141,6.047-27.211a12.9,12.9,0,0,0-5.5-9.07,13.169,13.169,0,0,0-5.5-1.924,10.294,10.294,0,0,0-8.52-4.123,6.049,6.049,0,0,0-2.2.275,9.555,9.555,0,0,0-6.047-3.3Z"
            fill="#415b91"
          />
          <path
            d="M118.166,50.842l-7.421,7.421a1.374,1.374,0,0,0,0,1.649l.549.55a1.374,1.374,0,0,0,1.649,0l8.8-8.8a1.374,1.374,0,0,0,0-1.649l-8.8-8.8a1.374,1.374,0,0,0-1.649,0l-.549.825a1.03,1.03,0,0,0,0,1.649Z"
            fill="#415b91"
          />
          <path
            d="M94.253,65.135A16.411,16.411,0,0,0,83.808,36c-9.07,0-17.041,7.421-17.041,16.492a17.88,17.88,0,0,0,7.971,14.293V61.012a13.987,13.987,0,0,1-3.573-8.521,12.094,12.094,0,1,1,24.188,0,11.638,11.638,0,0,1-3.3,8.246Z"
            fill="#415b91"
            opacity="0.5"
          />
        </g>
      </svg>
    </div>

    <div class="text-column">
      <span class="text">{{ $t('Click and slide') }},</span>
      <span class="text">{{ $t('to rotate the building') }}</span>
    </div>

  </div>
</template>

<script>
import CloseIcon from './icons/CloseIcon.vue'
export default {
  components: { CloseIcon },
  name: 'RotateTooltip'
}
</script>

<style lang="scss" scoped>
@import "~@/styles/RotateTooltip.scss";
</style>
